import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=8e3ebe20"
import script from "./SelectCourse.vue?vue&type=script&lang=js"
export * from "./SelectCourse.vue?vue&type=script&lang=js"
import style0 from "./SelectCourse.vue?vue&type=style&index=0&id=8e3ebe20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports